import React, { FC, Ref } from 'react';

import { Skeleton } from 'antd';
import { T } from 'react-translator-component';

import DateRangeLabel from './DateRangeLabel';
import * as S from './styled';

import { COLORS } from '../../../utils/theme/colors';
import DateRangeModal, {
  IDateRangeModalRef,
  datesRangeType,
} from '../../atoms/DateRangeModal';
import DashboardIcon from '../../atoms/icons/DashboardIcon';
import StationIndicator from '../../molecules/IndicatorsCharts/stations';
import SustainabilityIndicator from '../../molecules/IndicatorsCharts/sustainability';
import UserIndicator from '../../molecules/IndicatorsCharts/users';

export type HomeIndicatorsProps = {
  allStats: any;
  openDateRange: () => void;
  datesRangeValue: datesRangeType;
  dateRangeRef: Ref<IDateRangeModalRef>;
  START: string;
  END: string;
  handleChangeDateRange: (rage: datesRangeType) => void;
  MIN_START: Date;
  MAX_END: Date;
  environLoading: boolean;
  infoLoading: boolean;
};

const HomeIndicators: FC<HomeIndicatorsProps> = ({
  allStats,
  openDateRange,
  datesRangeValue,
  dateRangeRef,
  START,
  END,
  handleChangeDateRange,
  MIN_START,
  MAX_END,
  environLoading,
  infoLoading,
}) => {
  const Header = () => (
    <>
      <S.Header>
        <S.Title>
          <S.WrapperIcon>
            <DashboardIcon fill={COLORS.black} />
          </S.WrapperIcon>
          {T('General View')}
        </S.Title>

        <S.DateRangeWrapper onClick={openDateRange}>
          <DateRangeLabel
            start={datesRangeValue.start}
            end={datesRangeValue.end}
          />
        </S.DateRangeWrapper>
      </S.Header>

      <DateRangeModal
        ref={dateRangeRef}
        initialDates={{ start: START, end: END }}
        format='YYYY-MM-DD HH:mm:ss'
        onChange={handleChangeDateRange}
        minDate={MIN_START}
        maxDate={MAX_END}
      />
    </>
  );

  const slides = [
    infoLoading ? (
      <Skeleton.Button
        key={`home-indicators-loading-${Math.random()}`}
        active
      />
    ) : (
      <UserIndicator
        key={allStats?.users?.charged}
        {...{
          usersCharged: allStats?.users?.charged,
          usersRegistered: allStats?.users?.registered,
        }}
      />
    ),
    infoLoading ? (
      <Skeleton.Button
        key={`home-indicators-loading-${Math.random()}`}
        active
      />
    ) : (
      <StationIndicator
        key={allStats?.stations?.total}
        {...{
          total: allStats?.stations?.total,
          inUse: allStats?.stations?.inUse,
          available: allStats?.stations?.available,
          unavailable: allStats?.stations?.unavailable,
          maintenance: allStats?.stations?.maintenance,
        }}
      />
    ),
    environLoading ? (
      <Skeleton.Button
        key={`home-indicators-loading-${Math.random()}`}
        active
      />
    ) : (
      <SustainabilityIndicator
        key={allStats?.co2Saved}
        co2Saved={allStats?.co2Saved}
        treePercentageGoal={allStats?.treePercentageGoal}
        cultivatedTree={allStats?.cultivatedTree}
      />
    ),
  ];

  return (
    <S.Wrapper>
      <Header />

      <S.Skeleton>
        <S.IndicatorsWrapper>
          {slides.map((slide) => slide)}
        </S.IndicatorsWrapper>
      </S.Skeleton>
    </S.Wrapper>
  );
};

export default HomeIndicators;
